module.exports = __webpack_public_path__ + "img/resolved.bd6c37de.svg";